import { z } from 'zod';

export const formSchema = z.object({
  ma_kbh: z
    .string()
    .nonempty('Mã kênh bán hàng là bắt buộc')
    .refine(val => !val.includes(' '), {
      message: 'Mã kênh bán hàng không được chứa dấu cách'
    }),
  ma_cuahang: z
    .string()
    .optional()
    .refine(val => !val || !val.includes(' '), {
      message: 'Mã cửa hàng không được chứa dấu cách'
    }),
  tl_hoahong: z.coerce.number().min(0, 'Tỉ lệ hoa hồng không được âm').nullable(),
  loai_kenh: z.coerce.number().nullable(),
  status: z.number()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ma_kbh: '',
  ma_cuahang: '',
  tl_hoahong: null,
  loai_kenh: 1,
  status: 1
};
